module.exports = __webpack_public_path__ + "img/objects-links-bg-default.77fe123.jpeg";